import * as tf from '@tensorflow/tfjs';

const getModelPath = (modelName) => `${process.env.PUBLIC_URL}/modelo/${modelName}/modelTfjs/model.json`;
const getModelCacheKey = (modelName) => `indexeddb://flowsure-model-${modelName}`;
const modelPromises = new Map();
const modelInstances = new Map();

export const preloadModelAssets = async (modelName) => {
  if (!modelName || typeof window === 'undefined' || typeof fetch !== 'function') return;

  try {
    const modelUrl = getModelPath(modelName);
    const response = await fetch(modelUrl, { cache: 'force-cache' });
    if (!response.ok) return;

    const modelJson = await response.json();
    const manifests = Array.isArray(modelJson.weightsManifest) ? modelJson.weightsManifest : [];
    const baseUrl = modelUrl.substring(0, modelUrl.lastIndexOf('/') + 1);

    manifests.forEach((manifest) => {
      (manifest.paths || []).forEach((relativePath) => {
        fetch(new URL(relativePath, baseUrl).toString(), { cache: 'force-cache' }).catch(() => {});
      });
    });
  } catch (_error) {
    // Prefetch silencioso: no debe interrumpir el flujo del usuario.
  }
};

export const loadModelWithCache = async (modelName, onProgress) => {
  if (modelInstances.has(modelName)) {
    if (typeof onProgress === 'function') onProgress(1);
    return { model: modelInstances.get(modelName), source: 'memory' };
  }

  if (modelPromises.has(modelName)) {
    const pending = await modelPromises.get(modelName);
    if (typeof onProgress === 'function') onProgress(1);
    return pending;
  }

  const loadPromise = (async () => {
  const cacheKey = getModelCacheKey(modelName);

    try {
      const cached = await tf.loadGraphModel(cacheKey);
      modelInstances.set(modelName, cached);
      if (typeof onProgress === 'function') onProgress(1);
      return { model: cached, source: 'indexeddb' };
    } catch (_error) {
      // Sigue a red si no existe en cache.
    }

    const networkModel = await tf.loadGraphModel(getModelPath(modelName), {
      onProgress
    });

    try {
      await networkModel.save(cacheKey);
    } catch (_error) {
      // Si IndexedDB no está disponible, continuar sin persistencia.
    }

    modelInstances.set(modelName, networkModel);
    return { model: networkModel, source: 'network' };
  })();

  modelPromises.set(modelName, loadPromise);

  try {
    return await loadPromise;
  } finally {
    modelPromises.delete(modelName);
  }
};

export const prewarmModel = async (modelName) => {
  if (!modelName) return null;
  try {
    return await loadModelWithCache(modelName);
  } catch (_error) {
    return null;
  }
};
